import { z } from 'zod';
export const DEFAULT_FACTORY_IDENTITY_FORMAT = 'EVI-{po}-{nn}-{rand4}';
export const FactorySettingsSchema = z.object({
    identity_format: z.string().min(12).max(60).refine(s => ['{po}', '{nn}', '{rand4}'].every(t => s.split(t).length === 2)
        && /^[A-Z0-9_-]*$/.test(s.replace('{po}', '').replace('{nn}', '').replace('{rand4}', '')), 'Include each token {po}, {nn}, {rand4} exactly once; other characters must be uppercase letters, numbers, _ or -.'),
    default_window_days: z.number().int().min(1).max(365),
    models: z.array(z.object({ model: z.string().trim().min(1).max(160), enabled: z.boolean() }).strict()).max(300),
}).strict();
export const DEFAULT_FACTORY_SETTINGS = { identity_format: DEFAULT_FACTORY_IDENTITY_FORMAT, default_window_days: 90, models: [] };
export const factoryModelKey = (model) => model.trim().toLowerCase();
/** AuthorizationKey is hex on the wire; Basic auth uses the original UTF-8 password. */
export function factoryAuthorizationKeyValue(password) {
    if (!/^[\x21-\x7e]{16,20}$/.test(password))
        throw Error('Factory Basic-auth password must contain 16 to 20 ASCII bytes.');
    return Array.from(password, char => char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
}
export function formatFactoryIdentity(format, po, ordinal, suffix) {
    FactorySettingsSchema.shape.identity_format.parse(format);
    if (!Number.isSafeInteger(po) || po < 1018 || !Number.isSafeInteger(ordinal) || ordinal < 1 || !/^[A-Z0-9]{4}$/.test(suffix))
        throw Error('Invalid identity components.');
    const identity = format.replace('{po}', String(po)).replace('{nn}', String(ordinal).padStart(2, '0')).replace('{rand4}', suffix);
    if (identity.length > 64)
        throw Error('Identity exceeds the OCPP station ID limit. Shorten the format.');
    return identity;
}
export function factoryAdmissionAllowed(unit, now = new Date()) {
    return !!unit.approved_at && +new Date(unit.approved_at) <= +now && !!unit.window_ends_at && +new Date(unit.window_ends_at) > +now
        && !unit.revoked_at && !unit.closed_at && !['verified', 'revoked'].includes(unit.state)
        && (unit.kind === 'test' || ((unit.poApproved || unit.kind === 'home') && unit.enabled));
}
export function factoryWindowEnd(approval, days, manifestShip) {
    return new Date(+(manifestShip ?? approval) + days * 86400000);
}
//# sourceMappingURL=factoryProvisioning.js.map